(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypesSearchService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ContentTypesSearchService]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypesService
	 * 
	 * @description
	 * Exposes methods for retrieving content types that belong to a content
	 * type group.
	 */
	function ContentTypesSearchService($http, $q, gettextCatalog, pxUriPathService) {
		
		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypesService.getContentTypes
			 * @methodOf smb-app.smbContentTypesService
			 * @kind function
			 * 
			 * @description
			 * Gets all content types the belong to a content type group
			 * 
			 * @param {Number} groupId Id of the content type group
			 * 
			 * @returns {Deferred} A promise that will resolve to a collection of content types
			 */
			getContentTypes: getContentTypes
		};

		function getContentTypes(groupId) {
			if (!groupId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
			}

			var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/folders');
			return $http.get(uri)
				.then(function (response) {
					return response.data.filter(function (lib) {
											return !lib.IsPrivate;
										});
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentTypesSearchService.js
// module id = 144
// module chunks = 1